import React from 'react'
import PropTypes from 'prop-types'

export default class Mensagens extends React.Component {

  showMsgI () {
    if (this.props.vagasI % this.props.gruposPorHora != 0)
      return <small style={{color: 'red'}}>Vagas de Internet devem ser múltiplas de {this.props.gruposPorHora}<br/></small>
  }

  showMsgL () {
    if (this.props.vagasL % this.props.gruposPorHora != 0)
      return <small style={{color: 'red'}}>Vagas de Balcão devem ser múltiplas de {this.props.gruposPorHora}</small>
  }

  render () {
    return (
      <div>
        {this.showMsgI()}
        {this.showMsgL()}
      </div>
    );
  }
}

Mensagens.propTypes = {
  vagasI: PropTypes.number,
  vagasL: PropTypes.number,
  gruposPorHora: PropTypes.number
};
